import PropTypes from 'prop-types';
import { forwardRef, useEffect } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Card, CardContent, CardHeader, Divider, Stack, Typography } from '@mui/material';

// constant
const headerSX = {
    '& .MuiCardHeader-action': { mr: 0 }
};

// ==============================|| CUSTOM MAIN CARD ||============================== //

const MainCard = forwardRef(
    (
        {
            border = true,
            boxShadow,
            children,
            content = true,
            contentClass = '',
            contentSX = {},
            darkTitle,
            secondary,
            shadow,
            sx = {},
            dividerSx = {},
            title,
            srcIcon = null,
            imgWidth = "45px",
            imgHeight = "40px",
            ...others
        },
        ref
    ) => {
        const theme = useTheme();

        return (
            <Card
                ref={ref}
                {...others}
                sx={{
                    border: border ? '1px solid' : 'none',
                    borderColor: theme.palette.primary[200] + 75,
                    ':hover': {
                        boxShadow: boxShadow ? shadow || '0 2px 14px 0 rgb(32 40 45 / 8%)' : 'inherit'
                    },
                    ...sx
                }}
            >
                {/* card header and action */}
                <Stack spacing={1} direction="row">
                    {srcIcon && (
                        <Box paddingLeft="10px" display="flex" alignItems="center" justifyContent="center">
                            <img
                                width={imgWidth}
                                height={imgHeight}
                                alt="img"
                                src={srcIcon ?? null}
                            />
                        </Box>
                    )}
                    {!darkTitle && title && <CardHeader sx={{ ...headerSX, color: '#676767', marginLeft: '-10px !important' }} title={title} action={secondary} />}
                    {darkTitle && title && (
                        <CardHeader sx={{ ...headerSX, marginLeft: '-10px !important' }} title={<Typography variant="h3">{title}</Typography>} action={secondary} />
                    )}
                </Stack>

                {/* content & header divider */}
                {title && <Divider sx={{ ...dividerSx }} />}
                {/* card content */}
                {content && (
                    <CardContent sx={contentSX} className={contentClass}>
                        {children}
                    </CardContent>
                )}
                {!content && children}
            </Card>
        );
    }
);

MainCard.propTypes = {
    border: PropTypes.bool,
    boxShadow: PropTypes.bool,
    children: PropTypes.node,
    content: PropTypes.bool,
    contentClass: PropTypes.string,
    contentSX: PropTypes.object,
    darkTitle: PropTypes.bool,
    secondary: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object]),
    shadow: PropTypes.string,
    sx: PropTypes.object,
    dividerSx: PropTypes.object,
    title: PropTypes.oneOfType([PropTypes.node, PropTypes.string, PropTypes.object])
};

export default MainCard;
